const { getLanguage } = require('core/i18n').i18n;

const localLang = getLanguage();

const image1 = require(`assets/images/tutorials/${localLang}/general15/slide1.svg`);

const images = [image1];

module.exports = images;
